<template>
  <div class="map-container">
    <div class="map-search absolute">
      <div class="cause-search flex items-center bg-white">
        <button
          v-ripple
          v-if="hasBack.indexOf($route.path) !== -1"
          type="button"
          class="btn-empty-wrapper"
          @click="clickHandler"
        >
          <img
            class="left-back-icon"
            :srcset="`${chevronLeft}, ${chevronLeft}`"
            :src="`${chevronLeft}`"
            alt="Thrive"
            width="auto"
            height="auto"
          />
          <!-- <Close icon="back"></Close> -->
        </button>
        <div
          class="input-search-container flex-grow"
          ref="pacInputContainer"
          id="pacInputContainer"
        >
          <input
            id="pacInput"
            ref="pacInput"
            class="w-full"
            type="text"
            :placeholder="placeholder"
            :value="userPlace"
            @focus="clearPlace"
            @blur="setPlace"
            @input="setSearchBox"
          />
        </div>
        <button
          class="map-search__settings"
          type="button"
          @click="mapFilterHandler"
        >
          <SettingsIcon />
        </button>
        <button
          class="map-search__location"
          type="button"
          @click="setMyLocation"
        >
          <LocationIcon />
        </button>
      </div>
    </div>
    <div id="map" class="map-block" ref="map"></div>
  </div>
</template>

<script>
import mixins from "../../config/mixins";
import Close from "../UI/Close";
import SettingsIcon from "../Icons/SettingsIcon";
import LocationIcon from "../Icons/LocationIcon";

export default {
  name: "GoogleMap",

  props: {
    causes: {
      default: []
    },
    miles: {
      default: 1
    },
    routePath: {
      default: ""
    }
  },

  mixins: [mixins.npos],

  components: {
    LocationIcon,
    SettingsIcon,
    Close
  },

  data: function() {
    return {
      map: null,
      autocomplete: null,
      mapCenter: {
        lat: 0,
        lng: 0
      },
      markers: [],
      prev_infowindow: false,
      circles: {
        circle: null,
        marker: null
      },
      placeholder: "",
      hasBack: ["/login", "/npos", "/locations"],
      coords: {
        lat: "",
        lng: ""
      },
      userPlace: "",
      geocoder: null,
      geocoding: true,
      initMapIfError: true,
      searchBox: "",
      showAlert: false
    };
  },
  computed: {
    chevronLeft() {
      return `${this.$store.state.appUrl}/img/pwa/login/chevronLeft.svg`;
    }
  },
  watch: {
    causes: function() {
      this.reloadMarkers();
    }
  },

  mounted() {
    if (this.$route.path !== "/login") {
      this.placeholder = this.$t("Search");
    }

    this.setMyLocation();

    if (
      this.$getState("useUserLocation") ||
      this.$getState("useSearchLocation")
    ) {
      this.mapCenter = this.$getState("userLocation");

      if (this.mapCenter.lat && this.mapCenter.lng) {
        this.userPlace = this.$getState("userPlace");
        this.initMap();
        if (!!this.$parent.clearData) {
          this.$parent.clearData();
        }
      } else {
        this.setMyLocation();
      }
    } else {
      this.initMap();
      if (!!this.$parent.clearData) {
        this.$parent.clearData();
      }
    }
  },

  methods: {
    clearPlace: function() {
      this.userPlace = "";
    },
    setPlace: function() {
      this.userPlace = this.$getState("userPlace");
    },
    changePlace: function() {
      this.$setState("useUserLocation", false);
      this.$setState("useSearchLocation", true);
      this.$emit("update-list");
    },
    setSearchBox: function(event) {
      this.searchBox = event.target.value;
    },
    setMyLocation: function() {
      // if(!this.initMapIfError) return false;

      if (navigator.geolocation) {
        const $this = this;

        navigator.geolocation.getCurrentPosition(this.showPosition, function(
          e
        ) {
          console.log("Error.code: " + e.code + " Error.message: " + e.message);

          if (e.message !== undefined && e.message)
            $this.$toastr.Add({
              name: "UserGeoDataError",
              msg: e.message,
              clickClose: true,
              type: "error",
              preventDuplicates: true
            });
          $this.initMapIfError = false;
          $this.mapCenter.lat = 34.61249;
          $this.mapCenter.lng = -117.828119;
          $this.initMap();
        });
      } else {
        $this.$toastr.Add({
          name: "UserGeoDataError",
          msg: "Error: Your device doesn't support geolocation.",
          clickClose: true,
          type: "error",
          preventDuplicates: true
        });
        this.initMap();
      }
    },
    mapFilterHandler: function() {
      if (this.routePath) {
        this.$router.push(this.routePath);
      } else {
        this.$setState("showAppFilters", true);
        this.$setState("showGoogleMap", false);
        this.$setState("typeAppFilter", "map");
        this.$setState("isNavigation", false);
      }
    },
    clickHandler: function() {
      this.$emit("showGoogleMapHandler");
    },
    geocodeLatLng: function(latlng) {
      if (!latlng.lat && !latlng.lng) return;
      this.geocoder
        .geocode({ location: latlng })
        .then(response => {
          if (!!response.results[0]) {
            this.userPlace = response.results[0].formatted_address;
            this.$setState("userPlace", this.userPlace);
          } else {
            this.userPlace = this.$t("Unknown place");
            this.$setState("userPlace", this.userPlace);
          }
        })
        .catch(e => {
          this.geocoding = false;
          this.$toastr.Add({
            name: "GeocoderFailed",
            msg: e.message,
            clickClose: true,
            type: "error",
            preventDuplicates: true
          });
        });
    },
    initMap: function() {
      let mapCenter = this.mapCenter;

      // if (!this.mapCenter.lat && !this.mapCenter.lng) {
      // this.setMyLocation();
      // mapCenter = this.mapCenter;
      // mapCenter = {
      //     lat: 40.6974034,
      //     lng: -74.1197633,
      // };
      // }

      const mapDiv = document.getElementById("map");

      if (mapDiv) {
        this.map = new google.maps.Map(document.getElementById("map"), {
          center: mapCenter,
          zoom: 13,
          maxZoom: 20,
          minZoom: 2,
          zoomControl: false,
          fullscreenControl: false,
          streetViewControl: false,
          mapTypeControl: false
        });
        if (
          mapCenter.lat !== undefined &&
          mapCenter.lng !== undefined &&
          this.geocoding
        ) {
          this.geocoder = new google.maps.Geocoder();
          this.geocodeLatLng(mapCenter);
        }
        this.setMarkers();
        this.setCircle();
        const input = this.$refs.pacInput;
        const defaultBounds = {
          north: this.mapCenter.lat + 0.1,
          south: this.mapCenter.lat - 0.1,
          east: this.mapCenter.lng + 0.1,
          west: this.mapCenter.lng - 0.1
        };
        const options = {
          bounds: defaultBounds,
          fields: ["address_components", "geometry", "icon", "name"],
          strictBounds: false,
          types: ["establishment"]
        };

        this.autocomplete = new google.maps.places.Autocomplete(input, options);
        this.autocomplete.addListener("place_changed", this.placeChanged);
      }
    },
    placeChanged: function() {
      const place = this.autocomplete.getPlace();
      if (!place) return;

      if (!place.geometry || !place.geometry.location) {
        if (place.name === this.searchBox) {
          this.$toastr.Add({
            name: "UserSearchGeoDataError",
            msg: "No details available for input: '" + place.name + "'",
            clickClose: true,
            type: "error",
            preventDuplicates: true
          });
        }
        this.userPlace = this.searchBox;
        return;
      }

      if (!!place && !!place.geometry) {
        this.mapCenter.lat = parseFloat(place.geometry.location.lat());
        this.mapCenter.lng = parseFloat(place.geometry.location.lng());
      }

      this.changePlace();
      this.$setState("userLocation", {
        lat: this.mapCenter.lat,
        lng: this.mapCenter.lng
      });
      this.initMap();
    },
    showPosition: function(position) {
      this.mapCenter.lat = parseFloat(position.coords.latitude);
      this.mapCenter.lng = parseFloat(position.coords.longitude);
      this.$setState("userLocation", {
        lat: this.mapCenter.lat,
        lng: this.mapCenter.lng
      });
      this.$setState("useSearchLocation", false);
      this.$setState("useUserLocation", true);
      this.userPlace = "";
      this.$setState("userPlace", "");
      this.initMap();
    },
    setInfoWindow: function(post) {
      const images = this.getNposJson(post.img);
      let image = "";
      const title = this.getLocalizationData(post.title);
      let category = "";
      if (post.categories && post.categories.name !== undefined) {
        category = this.getLocalizationData(post.categories.name);
      }

      if (images.length) {
        image = this.getNposImage(images[0]);
      }

      let rate = 0;
      let postRate = 0;

      if (!!post.rate) {
        postRate = parseFloat(post.rate);
        rate = (postRate / 5) * 100;
      }

      let stars =
        "" +
        '<svg class="svg-defs" style="position: absolute; width: 0; height: 0" xmlns="http://www.w3.org/2000/svg" width="30" height="32" viewBox="0 0 30 32">' +
        '   <clipPath id="star">' +
        '      <path d="M29.7,11c0,0.3-0.2,0.5-0.5,0.9l-6.5,6.3l1.5,8.9c0,0.1,0,0.2,0,0.4c0,0.2-0.1,0.5-0.2,0.6c-0.1,0.2-0.3,0.3-0.5,0.3\n' +
        "\tc-0.2,0-0.5-0.1-0.7-0.2l-8-4.2l-8,4.2c-0.3,0.1-0.5,0.2-0.7,0.2c-0.3,0-0.4-0.1-0.6-0.3c-0.1-0.2-0.2-0.4-0.2-0.6\n" +
        "\tc0-0.1,0-0.2,0-0.4l1.5-8.9l-6.5-6.3C0.1,11.5,0,11.2,0,11c0-0.4,0.3-0.7,1-0.8l9-1.3l4-8.1C14.2,0.2,14.5,0,14.9,0s0.6,0.2,0.9,0.7\n" +
        '\tl4,8.1l9,1.3C29.4,10.3,29.7,10.5,29.7,11z"/>' +
        '<path d="M64.7,11c0,0.3-0.2,0.5-0.5,0.9l-6.5,6.3l1.5,8.9c0,0.1,0,0.2,0,0.4c0,0.2-0.1,0.5-0.2,0.6s-0.3,0.3-0.5,0.3\n' +
        "\tc-0.2,0-0.5-0.1-0.7-0.2l-8-4.2l-8,4.2c-0.3,0.1-0.5,0.2-0.7,0.2c-0.2,0-0.4-0.1-0.6-0.3c-0.1-0.2-0.2-0.4-0.2-0.6\n" +
        "\tc0-0.1,0-0.2,0-0.4l1.5-8.9l-6.5-6.3C35.1,11.5,35,11.2,35,11c0-0.4,0.3-0.7,1-0.8l9-1.3l4-8.1C49.2,0.2,49.5,0,49.9,0\n" +
        '\ts0.6,0.2,0.9,0.7l4,8.1l9,1.3C64.4,10.3,64.7,10.5,64.7,11z"/>' +
        '<path d="M99.7,11c0,0.3-0.2,0.5-0.5,0.9l-6.5,6.3l1.5,8.9c0,0.1,0,0.2,0,0.4c0,0.2-0.1,0.5-0.2,0.6c-0.1,0.2-0.3,0.3-0.5,0.3\n' +
        "\tc-0.2,0-0.5-0.1-0.7-0.2l-8-4.2l-8,4.2c-0.3,0.1-0.5,0.2-0.7,0.2c-0.2,0-0.4-0.1-0.6-0.3c-0.1-0.2-0.2-0.4-0.2-0.6\n" +
        "\tc0-0.1,0-0.2,0-0.4l1.5-8.9l-6.5-6.3C70.1,11.5,70,11.2,70,11c0-0.4,0.3-0.7,1-0.8l9-1.3l4-8.1C84.2,0.2,84.5,0,84.9,0\n" +
        '\tc0.4,0,0.6,0.2,0.9,0.7l4,8.1l9,1.3C99.4,10.3,99.7,10.5,99.7,11z"/>' +
        '<path d="M134.7,11c0,0.3-0.2,0.5-0.5,0.9l-6.5,6.3l1.5,8.9c0,0.1,0,0.2,0,0.4c0,0.2-0.1,0.5-0.2,0.6s-0.3,0.3-0.5,0.3\n' +
        "\tc-0.2,0-0.5-0.1-0.7-0.2l-8-4.2l-8,4.2c-0.3,0.1-0.5,0.2-0.7,0.2c-0.2,0-0.4-0.1-0.6-0.3c-0.1-0.2-0.2-0.4-0.2-0.6\n" +
        "\tc0-0.1,0-0.2,0-0.4l1.5-8.9l-6.5-6.3c-0.3-0.3-0.4-0.6-0.4-0.9c0-0.4,0.3-0.7,1-0.8l9-1.3l4-8.1c0.2-0.5,0.5-0.7,0.9-0.7\n" +
        '\tc0.4,0,0.6,0.2,0.9,0.7l4,8.1l9,1.3C134.4,10.3,134.7,10.5,134.7,11z"/>' +
        '<path d="M169.7,11c0,0.3-0.2,0.5-0.5,0.9l-6.5,6.3l1.5,8.9c0,0.1,0,0.2,0,0.4c0,0.2-0.1,0.5-0.2,0.6s-0.3,0.3-0.5,0.3\n' +
        "\tc-0.2,0-0.5-0.1-0.7-0.2l-8-4.2l-8,4.2c-0.3,0.1-0.5,0.2-0.7,0.2c-0.2,0-0.4-0.1-0.6-0.3s-0.2-0.4-0.2-0.6c0-0.1,0-0.2,0-0.4\n" +
        "\tl1.5-8.9l-6.5-6.3c-0.3-0.3-0.4-0.6-0.4-0.9c0-0.4,0.3-0.7,1-0.8l9-1.3l4-8.1c0.2-0.5,0.5-0.7,0.9-0.7s0.6,0.2,0.9,0.7l4,8.1l9,1.3\n" +
        '\tC169.4,10.3,169.7,10.5,169.7,11z"/>' +
        "  </clipPath>" +
        '  <clipPath id="star-empty">' +
        '    <path d="M20.3,17.4l5.5-5.3l-7.5-1.1l-3.4-6.8l-3.4,6.8l-7.5,1.1l5.5,5.3l-1.3,7.5l6.8-3.6l6.7,3.6L20.3,17.4z M29.7,11\n' +
        "\tc0,0.3-0.2,0.5-0.5,0.9l-6.5,6.3l1.5,8.9c0,0.1,0,0.2,0,0.4c0,0.6-0.2,0.9-0.7,0.9c-0.2,0-0.5-0.1-0.7-0.2l-8-4.2l-8,4.2\n" +
        "\tc-0.3,0.1-0.5,0.2-0.7,0.2c-0.3,0-0.4-0.1-0.6-0.3c-0.1-0.2-0.2-0.4-0.2-0.6c0-0.1,0-0.2,0-0.4l1.5-8.9l-6.5-6.3\n" +
        "\tC0.1,11.5,0,11.2,0,11c0-0.4,0.3-0.7,1-0.8l9-1.3l4-8.1C14.2,0.2,14.5,0,14.9,0s0.6,0.2,0.9,0.7l4,8.1l9,1.3\n" +
        '\tC29.4,10.3,29.7,10.5,29.7,11L29.7,11z"/>' +
        '<path d="M55.3,17.4l5.5-5.3l-7.5-1.1l-3.4-6.8l-3.4,6.8l-7.5,1.1l5.5,5.3l-1.3,7.5l6.8-3.6l6.7,3.6L55.3,17.4z M64.7,11\n' +
        "\tc0,0.3-0.2,0.5-0.5,0.9l-6.5,6.3l1.5,8.9c0,0.1,0,0.2,0,0.4c0,0.6-0.2,0.9-0.7,0.9c-0.2,0-0.5-0.1-0.7-0.2l-8-4.2l-8,4.2\n" +
        "\tc-0.3,0.1-0.5,0.2-0.7,0.2c-0.2,0-0.4-0.1-0.6-0.3c-0.1-0.2-0.2-0.4-0.2-0.6c0-0.1,0-0.2,0-0.4l1.5-8.9l-6.5-6.3\n" +
        "\tC35.1,11.5,35,11.2,35,11c0-0.4,0.3-0.7,1-0.8l9-1.3l4-8.1C49.2,0.2,49.5,0,49.9,0s0.6,0.2,0.9,0.7l4,8.1l9,1.3\n" +
        '\tC64.4,10.3,64.7,10.5,64.7,11L64.7,11z"/>' +
        '<path d="M90.3,17.4l5.5-5.3l-7.5-1.1l-3.4-6.8l-3.4,6.8l-7.5,1.1l5.5,5.3l-1.3,7.5l6.8-3.6l6.7,3.6L90.3,17.4z M99.7,11\n' +
        "\tc0,0.3-0.2,0.5-0.5,0.9l-6.5,6.3l1.5,8.9c0,0.1,0,0.2,0,0.4c0,0.6-0.2,0.9-0.7,0.9c-0.2,0-0.5-0.1-0.7-0.2l-8-4.2l-8,4.2\n" +
        "\tc-0.3,0.1-0.5,0.2-0.7,0.2c-0.2,0-0.4-0.1-0.6-0.3c-0.1-0.2-0.2-0.4-0.2-0.6c0-0.1,0-0.2,0-0.4l1.5-8.9l-6.5-6.3\n" +
        "\tC70.1,11.5,70,11.2,70,11c0-0.4,0.3-0.7,1-0.8l9-1.3l4-8.1C84.2,0.2,84.5,0,84.9,0c0.4,0,0.6,0.2,0.9,0.7l4,8.1l9,1.3\n" +
        '\tC99.4,10.3,99.7,10.5,99.7,11L99.7,11z"/>' +
        '<path d="M125.3,17.4l5.5-5.3l-7.5-1.1l-3.4-6.8l-3.4,6.8l-7.5,1.1l5.5,5.3l-1.3,7.5l6.8-3.6l6.7,3.6L125.3,17.4z M134.7,11\n' +
        "\tc0,0.3-0.2,0.5-0.5,0.9l-6.5,6.3l1.5,8.9c0,0.1,0,0.2,0,0.4c0,0.6-0.2,0.9-0.7,0.9c-0.2,0-0.5-0.1-0.7-0.2l-8-4.2l-8,4.2\n" +
        "\tc-0.3,0.1-0.5,0.2-0.7,0.2c-0.2,0-0.4-0.1-0.6-0.3c-0.1-0.2-0.2-0.4-0.2-0.6c0-0.1,0-0.2,0-0.4l1.5-8.9l-6.5-6.3\n" +
        "\tc-0.3-0.3-0.4-0.6-0.4-0.9c0-0.4,0.3-0.7,1-0.8l9-1.3l4-8.1c0.2-0.5,0.5-0.7,0.9-0.7c0.4,0,0.6,0.2,0.9,0.7l4,8.1l9,1.3\n" +
        '\tC134.4,10.3,134.7,10.5,134.7,11L134.7,11z"/>' +
        '<path d="M160.3,17.4l5.5-5.3l-7.5-1.1l-3.4-6.8l-3.4,6.8l-7.5,1.1l5.5,5.3l-1.3,7.5l6.8-3.6l6.7,3.6L160.3,17.4z M169.7,11\n' +
        "\tc0,0.3-0.2,0.5-0.5,0.9l-6.5,6.3l1.5,8.9c0,0.1,0,0.2,0,0.4c0,0.6-0.2,0.9-0.7,0.9c-0.2,0-0.5-0.1-0.7-0.2l-8-4.2l-8,4.2\n" +
        "\tc-0.3,0.1-0.5,0.2-0.7,0.2c-0.2,0-0.4-0.1-0.6-0.3c-0.1-0.2-0.2-0.4-0.2-0.6c0-0.1,0-0.2,0-0.4l1.5-8.9l-6.5-6.3\n" +
        "\tc-0.3-0.3-0.4-0.6-0.4-0.9c0-0.4,0.3-0.7,1-0.8l9-1.3l4-8.1c0.2-0.5,0.5-0.7,0.9-0.7c0.4,0,0.6,0.2,0.9,0.7l4,8.1l9,1.3\n" +
        '\tC169.4,10.3,169.7,10.5,169.7,11L169.7,11z"/>' +
        "  </clipPath>" +
        '   <rect id="rating" width="120" height="30" clip-path="url(#star)"/>' +
        "</svg>" +
        '<div class="rating-eg">' +
        '  <svg class="rating" viewBox="0 0 170 30" data-rating="1.2">' +
        '    <rect class="bg-rect" x="0" y="0" width="100%" height="100%" clip-path="url(#star-empty)"></rect>' +
        '    <rect class="rating-rect" x="0" y="0" width="' +
        rate +
        '%" height="100%" clip-path="url(#star)"></rect>' +
        "  </svg>" +
        "</div>";

      return (
        '<div id="info-content p-4">' +
        "<div>" +
        '<img class="block w-full info-window-image" width="169" height="95" src="' +
        image +
        '" alt="' +
        title +
        '"/>' +
        "</div>" +
        "<h2 class='text-12 font-bold mb-1'>" +
        title +
        "</h2>" +
        "<div class='text-12 info-window-category'>" +
        category +
        "</div>" +
        "<div class='flex items-center mt-1 mb-1'>" +
        stars +
        "<span class='pl-2 text-cause_text'>" +
        postRate +
        "</span>" +
        "</div>" +
        "<div class='my-4'>" +
        "<button type='button' class='ml-3 open-qr-reader-btn cause-item__btn btn-bgr-accent text-16 text-center map-button ' id='select-button' accessKey='" +
        post.id +
        "'>" +
        "Select" +
        "</button>" +
        "</div>" +
        "</div>"
      );
    },
    setMarker: function(cause, label) {
      const position = cause.location ? cause.location : "";
      const map = this.map;
      if (position) {
        const location = this.getNposJson(position);
        const latLng = {
          lat: location.lat ? parseFloat(location.lat) : 0,
          lng: location.lng ? parseFloat(location.lng) : 0
        };

        const infowindow = new google.maps.InfoWindow({
          content: this.setInfoWindow(cause)
        });

        const marker = new google.maps.Marker({
          position: latLng,
          map,
          icon: `${this.$store.state.appUrl}/img/pwa/login/marker.png`,
          label: {
            text: String(label),
            color: "#FFF"
          }
        });
        marker.addListener("click", () => {
          if (this.prev_infowindow) {
            this.prev_infowindow.close();
          }
          this.prev_infowindow = infowindow;
          infowindow.open({
            anchor: marker,
            map,
            shouldFocus: false
          });
          setTimeout(() => {
            var btn = document.getElementById("select-button");
            if (btn) {
              btn.onclick = () => {
                const cause = this.causes.find(c => c.id == btn.accessKey);
                this.$emit("show-cause-detail", cause);
              };
            }
          }, 1000);
        });
        this.markers.push(marker);
      }
    },
    reloadMarkers: function() {
      for (let i = 0; i < this.markers.length; i++) {
        this.markers[i].setMap(null);
      }

      this.markers = [];
      if (this.causes.length === undefined) {
        let count = 1;
        for (let key in this.causes) {
          this.setMarker(this.causes[key], count++);
        }
      } else {
        if (this.causes.length) {
          this.causes.forEach((cause, i) => {
            this.setMarker(cause, i + 1);
          });
        }
      }
    },
    setMarkers: function() {
      if (this.causes.length) {
        this.causes.forEach((cause, i) => {
          this.setMarker(cause, i + 1);
        });
      }
    },
    reloadCircle: function() {
      this.circles.marker.setMap(null);
      this.circles.circle.setMap(null);
      this.circles = {
        marker: null,
        circle: null
      };

      this.setCircle();
    },
    setCircle: function() {
      if (!this.mapCenter.lat && !this.mapCenter.lng) return false;

      const map = this.map;
      const position = this.mapCenter;
      this.circles.marker = new google.maps.Marker({
        map,
        position,
        icon: new google.maps.MarkerImage(
          `${this.$store.state.appUrl}/img/pwa/mapSpritesheet.png`,
          new google.maps.Size(64, 65),
          new google.maps.Point(0, 0),
          new google.maps.Point(32, 28)
        ),
        title: "me"
      });

      this.circles.circle = new google.maps.Circle({
        strokeColor: "#0084FF",
        strokeOpacity: 1,
        strokeWeight: 1,
        fillColor: "#c2d4e7",
        fillOpacity: 0.31,
        map,
        // center: this.mapCenter,
        radius: this.miles * 1609.34
      });

      this.circles.circle.bindTo("center", this.circles.marker, "position");
    }
  }
};
</script>
